import { createFileRoute } from '@tanstack/react-router'

import { UserRoleDetail } from '~/pages/UserRoles/detail'

export const Route = createFileRoute('/_authenticated/user_roles/$planId/')({
  component: () => <UserRoleDetail />,
})

export const UserRoleDetailRoute = Route
